import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { getDasDeviceInfo } from "../../features/das-device-manager/dasDeviceManagerSlice";
import { getPublicEventAction } from "../../features/public-events-manager/publicEventsManagerSlice";
import { getWeatherDataAction } from "../../features/weather-widget/weatherWidgetSlice";

import usePrevious from "../../hooks/usePrevious";
import Contact from "./Contact";
import Balance from "./Balance";
import YourStay from "./YourStay";
import Memories from "./Memories";
import WeatherWidget from "./WeatherWidget";
import Spinner from "../../components/Spinner";

import {
  MainContainer,
  NavBar,
  IntroContainer,
  ScheduleContainer,
  DiscoverContainer,
  FooterContainer,
  Separator,
  ScheduleItem,
  ScheduleInfoContainer,
  DiscoverItem
} from "./styles";

import logo from "./imgs/nav-logos.svg";
import yourStay from "./imgs/your-stay.webp";
import contact from "./imgs/contact.webp";
import balance from "./imgs/balance.webp";
import memoriesCannes from "./imgs/memories-cannes.webp";
import poweredBy from "./imgs/digiseq-logo.svg";
import paymentServices from "./imgs/payme-swiss.svg";
import copyIconWhite from "./imgs/copy-icon-white.svg";

import packageJson from "../../../package.json";

const Cannes25 = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");
  const eventId = searchParams.get("eventId");

  const [copied, setCopied] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );
  const { dasDeviceInfo, gettingDasDeviceInfo, errorGettingDasDeviceInfo } =
    useSelector((state) => state.dasDevices);
  const { publicEvent, gettingPublicEvent, errorGettingPublicEvent } =
    useSelector((state) => state.publicEvents);

  const { infoCollectorEventData } = publicEvent || {};

  const { weatherData, loadingWeather, errorWeather } = useSelector(
    (state) => state.weatherWidget
  );

  const { activatingTicket, activatingTicketError } = useSelector(
    (state) => state.hugoBoss
  );

  const prevActivatingTicket = usePrevious(activatingTicket);
  const prevGettingDasDeviceInfo = usePrevious(gettingDasDeviceInfo);

  console.log({ errorGettingPublicEvent });

  const getSelectedOptionId = (fieldId) => {
    return dasDeviceInfo?.eventData?.[
      eventId
    ]?.infoCollector?.selectedChoices?.find((item) => item.fieldId === fieldId)
      ?.selectedOptionId;
  };

  const getHighlights = (selectedOptionId) => {
    if (
      !publicEvent?.infoCollectorEventData?.fields[0]?.options[0]
        ?.additionalData?.highlights
    )
      return null;

    const groupData = publicEvent?.infoCollectorEventData?.fields?.filter(
      (item) => item?.id === "group"
    )[0];

    const findOptions = groupData?.options?.find(
      (item) => item?.id === selectedOptionId
    );

    if (findOptions?.additionalData?.highlights) {
      return findOptions.additionalData.highlights;
    }

    return null;
  };

  useEffect(() => {
    if (prevActivatingTicket && !activatingTicketError) {
      dispatch(getDasDeviceInfo(serialNumber));
    }
  }, [prevActivatingTicket, activatingTicketError, dispatch, serialNumber]);

  useEffect(() => {
    if (
      prevGettingDasDeviceInfo &&
      !errorGettingDasDeviceInfo &&
      dasDeviceInfo?.eventData
    ) {
      dispatch(getPublicEventAction(Object.keys(dasDeviceInfo?.eventData)[0]));
    }
  }, [
    gettingDasDeviceInfo,
    prevGettingDasDeviceInfo,
    dasDeviceInfo?.eventData,
    errorGettingDasDeviceInfo,
    dispatch
  ]);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    dispatch(getWeatherDataAction({ latitude: 43.55138, longitude: 7.00948 }));
  }, [dispatch]);

  useEffect(() => {
    if (isMounted) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied, isMounted]);

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=pannovate"
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  useEffect(() => {
    if (serialNumber) {
      dispatch(getDasDeviceInfo(serialNumber));
    }
  }, [serialNumber, dispatch]);

  const [isMemoriesOpen, setIsMemoriesOpen] = useState(false);
  const [isBalanceOpen, setIsBalanceOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isYourStayOpen, setIsYourStayOpen] = useState(false);

  const handleClose = (closeItem) => {
    const discoverContainer = document.getElementById("discover");
    discoverContainer.scrollIntoView({ behavior: "smooth" });

    switch (closeItem) {
      case "memories":
        setIsMemoriesOpen(false);
        break;
      case "balance":
        setIsBalanceOpen(false);
        break;
      case "contact":
        setIsContactOpen(false);
        break;
      case "yourStay":
        setIsYourStayOpen(false);
        break;
      default:
        break;
    }
  };

  const handleOpen = (openItem) => {
    //scroll to top
    window.scrollTo(0, 0);
    switch (openItem) {
      case "memories":
        setIsMemoriesOpen(true);
        break;
      case "balance":
        setIsBalanceOpen(true);
        break;
      case "contact":
        setIsContactOpen(true);
        break;
      case "yourStay":
        setIsYourStayOpen(true);
        break;
      default:
        break;
    }
  };
  const parseHighlights = (highlights) => {
    const parsedHighlights = JSON.parse(highlights);

    return parsedHighlights;
  };

  const renderHighlights = () => {
    const selectedOptionId = getSelectedOptionId("group");

    if (!selectedOptionId) return null;
    const highlights = getHighlights(selectedOptionId);

    if (!highlights) return null;

    return (
      <>
        {parseHighlights(highlights)
          .filter(
            (item) => item.date === new Date().toISOString().split("T")[0]
          )
          .map((item, index) => {
            const formattedDate = new Date(item.date).toLocaleDateString(
              "en-GB",
              {
                weekday: "long",
                day: "numeric",
                month: "long",
                year: "numeric"
              }
            );
            return (
              <ScheduleItem key={index}>
                <div className="schedule-list">
                  <p>{formattedDate}</p>
                  <Separator />

                  {item?.schedule.map((scheduleItem, indexSchedule) => {
                    return (
                      <p className="schedule-item" key={indexSchedule}>
                        <span className="time">
                          {scheduleItem.time ? scheduleItem.time : ""}
                        </span>
                        {scheduleItem.time ? " - " : ""}
                        <span className={!scheduleItem.time ? "time" : ""}>
                          {scheduleItem.title}
                        </span>
                      </p>
                    );
                  })}
                </div>
              </ScheduleItem>
            );
          })}
      </>
    );
  };

  if (isLoading || gettingDasDeviceInfo || gettingPublicEvent)
    return <Spinner />;

  return (
    <MainContainer>
      <NavBar>
        <img src={logo} alt="logo" />
      </NavBar>
      <IntroContainer eventName={"CANNES"}>
        <div className="image-container">
          {dasDeviceInfo?.personalDetails?.firstName ? (
            <h1>
              {"Welcome,"}{" "}
              <span className="new-line">
                {dasDeviceInfo?.personalDetails?.firstName}{" "}
                {dasDeviceInfo?.personalDetails?.lastName}
              </span>
            </h1>
          ) : (
            <h1>{"Welcome to Cannes!"}</h1>
          )}
        </div>

        <div className="text-container">
          <p>
            We are delighted that you can join us for the 78th Cannes Film
            Festival.
          </p>
          <p>
            Enjoy a priceless experience among the stars with Mastercard, proud
            sponsor of your passions!
          </p>
        </div>
      </IntroContainer>
      <ScheduleContainer>
        <h2>{"Your Agenda"}</h2>
        {renderHighlights()}
      </ScheduleContainer>
      <ScheduleInfoContainer>
        <p>
          {
            "Mastercard Welcome Desks at Majestic Hotel will be available throughout the event should you have any query."
          }
        </p>
      </ScheduleInfoContainer>
      <Separator isLeft={true} />
      <DiscoverContainer id="discover">
        <h2>{"Experience Cannes"}</h2>
        <p>{"Tap to find out what there is to discover"}</p>
        <div className="items-container">
          <DiscoverItem onClick={() => handleOpen("yourStay")}>
            <img src={yourStay} alt="your stay" />
          </DiscoverItem>
          <DiscoverItem onClick={() => handleOpen("contact")}>
            <img src={contact} alt="contact" />
          </DiscoverItem>
          <DiscoverItem onClick={() => handleOpen("balance")}>
            <img src={balance} alt="balance" />
          </DiscoverItem>
          <DiscoverItem onClick={() => handleOpen("memories")}>
            <img src={memoriesCannes} alt="memories" />
          </DiscoverItem>
        </div>
      </DiscoverContainer>

      <FooterContainer>
        <h3>{"Powered by"}</h3>
        <img src={poweredBy} alt="powered by" />
        <h3>{"Payment services by"}</h3>
        <img src={paymentServices} alt="payment services" />
        <p>
          <a href="https://www.mastercard.com/global/en.html">
            {"Privacy Policy"}
          </a>
        </p>
        <p>
          <a href="https://www.mastercard.com/global/en.html">
            {"Terms & Conditions"}
          </a>
        </p>
        {serialNumber && (
          <div className="copyToClipboard">
            <p>ID: {serialNumber}</p>
            <img
              onClick={() => {
                navigator.clipboard.writeText(serialNumber);
                setCopied(true);
              }}
              src={copyIconWhite}
              alt="copy to clipboard"
            />
          </div>
        )}
        <div className="version">
          <p>v.{packageJson.version}</p>
        </div>
        {copied && (
          <p>
            <b>Copied to clipboard</b>
          </p>
        )}
      </FooterContainer>
      {isMemoriesOpen && (
        <Memories
          serialNumber={serialNumber}
          onClose={() => handleClose("memories")}
          eventName={"CANNES"}
        />
      )}
      {isBalanceOpen && (
        <Balance
          onClose={() => handleClose("balance")}
          remainingBalance={balanceAndPin?.balanceDetails?.availableBalance}
          activationCode={balanceAndPin?.activationCode}
          eventName={"CANNES"}
        />
      )}
      {isContactOpen && (
        <Contact onClose={() => handleClose("contact")} eventName={"CANNES"} />
      )}

      {isYourStayOpen && (
        <YourStay
          eventName={"CANNES"}
          onClose={() => handleClose("yourStay")}
          hotelInfo={
            infoCollectorEventData?.fields?.length > 0 &&
            infoCollectorEventData?.fields?.filter(
              (item) => item?.id === "hotel"
            )[0]
          }
          hotelOptions={
            dasDeviceInfo?.eventData?.[eventId]?.infoCollector?.selectedChoices
              ?.length > 0 &&
            dasDeviceInfo?.eventData?.[
              eventId
            ]?.infoCollector?.selectedChoices.filter(
              (item) => item?.fieldId === "hotel"
            )[0]
          }
        />
      )}
      {weatherData && (
        <div style={{ position: "fixed", top: "90%", right: "10px" }}>
          <WeatherWidget
            weatherData={weatherData}
            loading={loadingWeather}
            error={errorWeather}
          />
        </div>
      )}
    </MainContainer>
  );
};

export default Cannes25;
